module.exports = __webpack_public_path__ + "static/media/doTERRA-share-guide.36734f9b.png";